import { Box, Typography } from "@mui/material";
import React from "react";
import IconBox from "../UI/IconBox/IconBox";
import python from "../../images/python.svg";
import java from "../../images/java.svg";
import go from "../../images/gopher.svg";
import nodejs from "../../images/nodejs.svg";
import web from "../../images/webAssembly.png";

const HomeBottom = () => {
  return (
    <Box className="home-bottom">
      <Typography variant="h5">Supported Languages</Typography>

      <Box
        sx={{
          display: "flex",
          gap: "1rem",
          justifyContent: "center",
          flexWrap: "wrap",
        }}
      >
        <IconBox>
          <img src={python} alt={"Python"} width={50} height={50} />
          <Typography sx={{ fontSize: "0.75rem", fontWeight: 500 }}>
            Python
          </Typography>
        </IconBox>

        <IconBox>
          <img
            src={go}
            alt={"Go"}
            width={50}
            height={40}
            style={{ marginLeft: "23px", marginTop: "6px" }}
          />
          <Typography sx={{ fontSize: "0.75rem", fontWeight: 500, mt: 0.5 }}>
            GO
          </Typography>
        </IconBox>

        <IconBox>
          <img
            src={java}
            alt={"Java"}
            width={50}
            height={50}
            style={{ filter: "grayscale(1)" }}
          />
          <Typography sx={{ fontSize: "0.75rem", fontWeight: 500 }}>
            Java
          </Typography>
        </IconBox>

        <IconBox>
          <img
            src={nodejs}
            alt={"NodeJS"}
            width={50}
            height={50}
            style={{ filter: "grayscale(1)" }}
          />
          <Typography sx={{ fontSize: "0.75rem", fontWeight: 500 }}>
            NodeJS
          </Typography>
        </IconBox>

        <IconBox>
          <img
            src={web}
            alt={"Web Assembly"}
            width={40}
            height={40}
            style={{ filter: "grayscale(1)", marginTop: "6px" }}
          />
          <Typography sx={{ fontSize: "0.75rem", fontWeight: 500, mt: 1 }}>
            Web Assembly
          </Typography>
        </IconBox>
      </Box>

      <Typography variant="body1">
        Go and Python are supported languages. NodeJS, Java, and WASM (Web
        Assembly) are on the roadmap.
      </Typography>
    </Box>
  );
};

export default HomeBottom;
